import * as React from "react";

import Modal from "../misc/components/modal";
import AsyncActionButton from "../misc/components/AsyncActionButton";
import { CoughAnalysisSet, CoughSession } from "webportalclient";
import { Form, useField, useFormApi, withFormApi } from "informed";
import { DatePicker, DatePickerAcceptDateRange } from "../forms/informedv2/DatePicker";
import { useWebPortalLegacyClient } from "../misc/api/WebPortalTokenClient";
import * as Moment from 'moment';
import { AuditModalBody } from "../auditmodal/components/AuditModalBody";


export interface AnalysisDeadlinesModalProps {
    analysisSet: CoughAnalysisSet;
    onClose: () => void;
}


export interface CoughDeadlinesForm {
    AnalysisDeadline: string;
    QaDeadline: string;
}

export const AnalysisDeadlinesModal = ({ analysisSet, onClose }: AnalysisDeadlinesModalProps) => {
    const [submitting, setSubmitting] = React.useState(false);
    const [confirmed, setConfirmed] = React.useState(false);
    const qaDeadlineField = useField<string>({ field: "QaDeadline" });
    const analysisDeadlineField = useField<string>({ field: "AnalysisDeadline" });
    const client = useWebPortalLegacyClient();
    const minimumDate = "0001-01-01 00:00";

    React.useEffect(() => {
        if (analysisSet.qaDeadline)
            if (Moment(new Date(analysisSet.qaDeadline)) >= Moment(minimumDate))
                qaDeadlineField.fieldApi.setValue(Moment(new Date(analysisSet.qaDeadline)).format("YYYY-MM-DD HH:mm:ss"));
            else
                qaDeadlineField.fieldApi.setValue(minimumDate);
        if (analysisSet.analysisDeadline)
            if (Moment(new Date(analysisSet.analysisDeadline)) >= Moment(minimumDate))
                analysisDeadlineField.fieldApi.setValue(Moment(new Date(analysisSet.analysisDeadline)).format("YYYY-MM-DD HH:mm:ss"));
            else
                analysisDeadlineField.fieldApi.setValue(minimumDate);
    }, [analysisSet]);

    const handleSubmit = async () => {
        if ((analysisDeadlineField.fieldState.value == Moment(new Date(analysisSet.analysisDeadline)).format("YYYY-MM-DD HH:mm:ss") &&
            qaDeadlineField.fieldState.value == Moment(new Date(analysisSet.qaDeadline)).format("YYYY-MM-DD HH:mm:ss")) ||
            (!analysisDeadlineField.fieldState.value && !qaDeadlineField.fieldState.value && !analysisSet.qaDeadline && !analysisSet.analysisDeadline) 
        ) {
            onClose();
            return;
        }
        if ((analysisDeadlineField.fieldState.value && !analysisSet.analysisDeadline && (!analysisSet.qaDeadline || qaDeadlineField.fieldState.value == Moment(new Date(analysisSet.qaDeadline)).format("YYYY-MM-DD HH:mm:ss"))) ||
            (qaDeadlineField.fieldState.value && !analysisSet.qaDeadline && (!analysisSet.analysisDeadline || analysisDeadlineField.fieldState.value == Moment(new Date(analysisSet.analysisDeadline)).format("YYYY-MM-DD HH:mm:ss")))
        ) {
            setSubmitting(true);
            await client.updateAnalysisDeadlines(analysisSet.id, { AnalysisDeadline: analysisDeadlineField.fieldState.value, QaDeadline: qaDeadlineField.fieldState.value, Annotation: null });
            onClose();
            return;
        }
        setConfirmed(true);
    }

    const onHandleModalSubmit = async (annotation: string) => {
        setSubmitting(true);

        await client.updateAnalysisDeadlines(analysisSet.id, { AnalysisDeadline: analysisDeadlineField.fieldState.value, QaDeadline: qaDeadlineField.fieldState.value, Annotation: annotation });

        setSubmitting(false);
        onClose();
    }

    return (

        <Modal
            show={true}
            closeModalHandler={() => onClose()}
            header={confirmed ? "Approval" : "Cough Review Dates"}>
            {
                confirmed ?
                    <AuditModalBody isAuditAnnotationDisabled={false} isSubmitting={submitting} onSubmit={(form) => onHandleModalSubmit(form.Annotation)} onClose={onClose} annotationLabel="Annotation" submitLabel="Save" />
                    :
                    <Form<CoughDeadlinesForm>>

                        <div className="modal-body">

                            <DatePicker id="QaDeadline"
                                label="QA Required Date"
                                disabled={submitting}
                                includeTime={true}
                                required={false}
                                className="form-group"
                                acceptDateRange={DatePickerAcceptDateRange.All}
                                fieldApi={qaDeadlineField.fieldApi}
                                fieldState={qaDeadlineField.fieldState}
                                setValue={qaDeadlineField.fieldApi.setValue} />

                            <DatePicker id="AnalysisDeadline"
                                label="Analysis Required Date"
                                disabled={submitting}
                                includeTime={true}
                                required={false}
                                className="form-group"
                                acceptDateRange={DatePickerAcceptDateRange.All}
                                fieldApi={analysisDeadlineField.fieldApi}
                                fieldState={analysisDeadlineField.fieldState}
                                setValue={analysisDeadlineField.fieldApi.setValue} />
                        </div>

                        <div className="modal-footer">
                            <AsyncActionButton
                                isSubmitting={submitting}
                                className="btn btn-primary"
                                onClick={() => handleSubmit()}
                            >
                                Submit
                            </AsyncActionButton>
                            <button
                                className="btn btn-outline btn-primary"
                                onClick={() => onClose()}
                            >
                                Close
                            </button>
                        </div>
                    </Form>
            }
        </Modal>
    );
}

